import React, {Component} from "react";
import {
    api,
    apis,
    msg,
    rd,
    sendGet,
    throws,
    type_ment,
    type_modal,
    type_modal_icon,
    type_popup
} from "../../../vars/rd";
import {$shutils} from "../../../libs/snnh/snnh";
import {connect} from "react-redux";
import {popupShow} from "../../../libs/redux/actions/popup";
import {modalShow} from "../../../libs/redux/actions/modal";

class MentItem extends Component {
    constructor(props) {
        super(props);

        this.msg = msg();
        let type = props.type;
        if(!type) this.type = type_ment.default;

        const data = props.data;
        const popup = props.hasOwnProperty('popup') ? props.popup : true;

        /**
         *
         * @type {{data: DaoMent, type: string, popup: (boolean|null)}}
         */
        this.state = {
            data,
            type,
            popup
        };
    }

    get dispatch() {
        return this.props.hasOwnProperty('dispatch') ? this.props.dispatch : () => {};
    }

    listen(e) {
        e.stopPropagation();

        this.dispatch(
            modalShow(
                type_modal.confirm,
                {
                    icon: type_modal_icon.check,
                    header: this.data.title,
                    message: this.msg.confirm_play_ment,
                },
                async (rs) => {
                    if (rs) {
                        try {
                            const url = api(apis.ment_socket, {
                                serviceid: rd.user.serviceid,
                                groupid: rd.user.groupid,
                                cid: this.data.cid,
                                type: '<play_music>',
                                code: 'cme'
                            });
                            const json = await sendGet(url);
                            if(!json || json.result !== "OK" || json.status !== "OK") throws(this.msg.api_fail);
                        } catch (e) {
                            this.dispatch(
                                modalShow(
                                    type_modal.alert,
                                    {
                                        message: this.msg.fail_play_ment
                                    }
                                )
                            );
                        }
                    }
                }
            )
        );
    }

    detail(e) {
        e.stopPropagation();
        this.dispatch(popupShow(type_popup.ment, this.data, null));
    }

    /**
     *
     * @returns {DaoMent}
     */
    get data() {
        return this.state.data;
    }

    get reserveAt() {
        return this.data.time ? this.data.time.substring(0, 5) : '-';
    }

    render() {
        switch (this.state.type) {
            case type_ment.today:
                return (
                    <li>
                        <span className="time">{this.reserveAt}</span> <span className="title">{this.data.title}</span>
                    </li>
                )
                    ;
            case
            type_ment.popup
            :
                return (
                    <div className="item">
                        <div className="title">
                            <span>{this.data.category_name}</span>
                            <p>{this.data.title}</p>
                        </div>
                        <div className="time">{$shutils.toTime(this.data.playtime || 0)}</div>
                        <div className="btn-wrap">
                            <a onClick={e => this.listen(e)}><img src="/images/btn-listen.png" alt={'듣기'}/></a>
                        </div>
                    </div>
                );
            case
            type_ment.default
            :
            default:
                return (
                    <div className="item">
                        <div className="title">
                            <span>{this.data.category_name}</span>
                            <p>{this.data.title}</p>
                        </div>
                        <div className="time">{$shutils.toTime(this.data.playtime || 0)}</div>
                        <div className="btn-wrap">
                            <ul>
                                <li onClick={e => this.detail(e)}><img src="/images/btn-popup.png" alt={'상세보기'}/></li>
                                <li onClick={e => this.listen(e)}><img src="/images/btn-listen.png" alt={'듣기'}/></li>
                            </ul>
                        </div>
                    </div>
                );
        }
    }
}

export default connect()(MentItem);


// WEBPACK FOOTER //
// ./src/pages/components/elements/ment.item.jsx